import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CREATE, PUBLIC } from "constants/index"

type ListFormSlice = {
  formFields: WishListRequestPayload;
  prefilledFormFields: WishListRequestPayload;
  mode: FormMode;
  isPrefilled: boolean;
}

const initialState = {
  formFields: {
    name: "",
    privacy: PUBLIC
  },
  prefilledFormFields: {
    name: "",
    privacy: PUBLIC
  },
  mode: CREATE,
  isPrefilled: false
} as ListFormSlice

export const listFormSlice = createSlice({
  name: "listFormSlice",
  initialState: initialState,
  reducers: {
    updateListFormFields: (state, action: PayloadAction<WishListRequestPayload>) => {
      state.formFields = structuredClone(action.payload)
    },
    updateListFormMode: (state, action: PayloadAction<FormMode>) => {
      state.mode = action.payload
    },
    prefillListFormFields: (state, action: PayloadAction<WishListRequestPayload>) => {
      state.prefilledFormFields = structuredClone(action.payload)
      state.isPrefilled = true
    },
    resetListFormSlice: () => structuredClone(initialState)
  }
})

export const {
  updateListFormFields,
  updateListFormMode,
  prefillListFormFields,
  resetListFormSlice
} = listFormSlice.actions
export default listFormSlice.reducer
